import {takeLatest, call, put, all, takeEvery} from "redux-saga/effects";
import { normalize } from "normalizr";
import get from "lodash/get";

import { api, queryBuilder } from "@/services";

import EntityActions from "./actions";
import EntitiesActions from "@/store/actions/entities";
import EntitySchema from "./schema";

export function* LoadAll(action){

	const { entity, name, url, params, dataKey, metaKey, appendData, prependData, primaryKey, cb } = action.payload;

	try {

		const { data } = yield call(api.request.get, queryBuilder(url, params));

		const normalized = normalize(
			typeof dataKey === "function" ? dataKey(data) : data[dataKey],
			[EntitySchema(entity, primaryKey)]
		);

		yield put(EntitiesActions.Load.success(normalized.entities));

		yield put(EntityActions.LoadAll.success({
			ids: normalized.result,
			entity,
			name,
			appendData,
			prependData,
			params,
			meta: typeof metaKey === 'function' ? metaKey(data) : {
				currentPage: data.current_page,
				pageCount: data.last_page,
				perPage: data.per_page,
				totalCount: data.total
			}
		}));

		yield call(cb.success, data);

	} catch(error){

		yield put(EntityActions.LoadAll.failure({
			entity,
			name,
			error
		}));

		yield call(cb.error, error);

	}
}

export function* LoadOne(action){

	const { id, entity, name, url, params, primaryKey, cb, relations } = action.payload;

	try {

		const { data } = yield call(api.request.get, queryBuilder(url, params));

		let normalized = normalize(data, EntitySchema(entity, primaryKey, relations));

		if(primaryKey === id){
			normalized = normalize({[primaryKey]: id, ...data}, EntitySchema(entity, primaryKey, relations));
		}
		yield put(EntitiesActions.Load.success(normalized.entities));

		yield put(EntityActions.LoadOne.success({
			entity,
			name,
			params,
			id: id ? id : normalized.result,
		}));

		yield call(cb.success, data);

	} catch(error){

		yield put(EntityActions.LoadOne.failure({
			entity,
			name,
			error
		}));

		yield call(cb.error, error);
	}
}

export function* LoadDefault(action){

	const { url, params, cb, baseURL} = action.payload;

	try {
		if(baseURL){
			const { data } = yield call(api.request.get, queryBuilder(url, params), {baseURL});
			yield call(cb.success, data);
		}else{
			const { data } = yield call(api.request.get, queryBuilder(url, params));
			yield call(cb.success, data);
		}

	} catch(error){

		yield put(EntityActions.LoadDefault.failure({
			error
		}));

		yield call(cb.error, get(error, 'response.data', []));

	}
}

export function* Form(action){

	const { id, entity, name, url, params, method, primaryKey, isMulti, values, appendData, prependData, updateData, deleteData, normalizeData, cb } = action.payload;

	try {

		const { data } = yield call(api.request[method], queryBuilder(url, params), values);

		if (normalizeData) {
			const normalized = normalize(
				typeof normalizeData === "function" ? normalizeData(data) : data[normalizeData],
				isMulti ? [EntitySchema(entity, primaryKey)] : EntitySchema(entity, primaryKey)
			);

			yield put(EntitiesActions.Load.success(normalized.entities));

			yield put(
				EntityActions.Form.success({
					id: normalized.result,
					entity,
					name,
					appendData,
					prependData,
					updateData,
					deleteData
				})
			);
		}else{
			yield put(
				EntityActions.Form.success({
					id,
					entity,
					name,
					appendData,
					prependData,
					updateData,
					deleteData
				})
			);
		}

		yield call(cb.success, data);

	} catch(error){

		yield put(EntityActions.Form.failure({
			id,
			entity,
			name,
			error
		}));

		yield call(cb.error, get(error, 'response.data', []));

	} finally {
		yield call(cb.finally);
	}
}

export function* FormWithData(action){

	const { data, entity, primaryKey, name, appendData, prependData, updateData, deleteData, cb } = action.payload;

	try {
		const normalized = normalize(
			data,
			EntitySchema(entity, primaryKey)
		);

		yield put(EntitiesActions.Load.success(normalized.entities));

		yield put(
			EntityActions.Form.success({
				id: normalized.result,
				entity,
				name,
				appendData,
				prependData,
				updateData,
				deleteData
			})
		);

	} catch(error){
		yield call(cb.error, get(error, 'response.data', []));

	} finally {
		yield call(cb.finally);
	}
}

export function* FormDefault(action){

	const {url, params, method, values, cb} = action.payload;

	try {

		const { data } = yield call(api.request[method], queryBuilder(url, params), values);

		yield call(cb.success, data);

	} catch(error){

		yield put(EntityActions.FormDefault.failure({
			error
		}));

		yield call(cb.error, get(error, 'response.data', []));

	} finally {
		yield call(cb.finally);
	}
}

export default function* root(){
	yield all([
		takeEvery(EntityActions.LoadAll.REQUEST, LoadAll),
		takeEvery(EntityActions.LoadOne.REQUEST, LoadOne),
		takeEvery(EntityActions.LoadDefault.REQUEST, LoadDefault),
		takeLatest(EntityActions.Form.REQUEST, Form),
		takeLatest(EntityActions.FormDefault.REQUEST, FormDefault),
		takeLatest(EntityActions.FormWithData.TRIGGER, FormWithData),
	]);
}
